/* eslint-disable */
import gql from 'graphql-tag';

export const SAVE_BUILDER = gql`
mutation saveBuilder($eventID: ID!, $items: [JSON!], $backgroundImage: String, $format: String, $orientation: String) {
  saveBuilder(eventId: $eventID, items: $items, backgroundImage: $backgroundImage, format: $format, orientation: $orientation ) {
    id
    eventId
    items
    backgroundImage
    format
    orientation
    
  }
}`;
